import { LoadSharedUserConfigAction } from 'app/redux/sharedUserConfig/actions';
import {
  AcquisitionConstantsByProfile,
  AcquisitionConstantsList,
} from 'app/utils/acquisitionConstants';

export const XRAY_CONFIGURATION_SET_DEVICE_PATH = 'XRAY_CONFIGURATION.SET_DEVICE_PATH' as const;
export const XRAY_CONFIGURATION_TOGGLE_TELEMETRY = 'XRAY_CONFIGURATION.TOGGLE_TELEMETRY' as const;
export const XRAY_CONFIGURATION_TOGGLE_DIRECT_COMMUNICATION_MODE =
  'XRAY_CONFIGURATION.TOGGLE_DIRECT_COMMUNICATION_MODE' as const;
export const XRAY_CONFIGURATION_ADD_OPERATOR = 'XRAY_CONFIGURATION.ADD_OPERATOR' as const;
export const XRAY_CONFIGURATION_SET_LAST_OPERATORS =
  'XRAY_CONFIGURATION.SET_SELECTED_OPERATORS' as const;
export const XRAY_CONFIGURATION_DELETE_OPERATOR = 'XRAY_CONFIGURATION.DELETE_OPERATOR' as const;
export const XRAY_CONFIGURATION_UPDATE_ACQUISITION_CONSTANT =
  'XRAY_CONFIGURATION.UPDATE_ACQUISITION_CONSTANT' as const;
export const XRAY_CONFIGURATION_IMPORT_ACQUISITION_CONSTANT =
  'XRAY_CONFIGURATION.IMPORT_ACQUISITION_CONSTANT' as const;

export const setDevicePath = (devicePath: string) => ({
  type: XRAY_CONFIGURATION_SET_DEVICE_PATH,
  payload: { devicePath },
});
export const toggleDirectCommunicationMode = (isDirectCommunicationMode: boolean) => ({
  type: XRAY_CONFIGURATION_TOGGLE_DIRECT_COMMUNICATION_MODE,
  payload: { isDirectCommunicationMode },
});
export const toggleTelemetry = (isTelemetry: boolean) => ({
  type: XRAY_CONFIGURATION_TOGGLE_TELEMETRY,
  payload: { isTelemetry },
});
export const addOperator = (operator: string) => ({
  type: XRAY_CONFIGURATION_ADD_OPERATOR,
  payload: { operator },
});
export const setSelectedOperators = (operators: string[]) => ({
  type: XRAY_CONFIGURATION_SET_LAST_OPERATORS,
  payload: { operators },
});
export const deleteOperator = (operator: string) => ({
  type: XRAY_CONFIGURATION_DELETE_OPERATOR,
  payload: { operator },
});

export const updateAcquisitionConstant = (
  profile: string,
  acquisitionConstantsList: AcquisitionConstantsList
) => ({
  type: XRAY_CONFIGURATION_UPDATE_ACQUISITION_CONSTANT,
  payload: { profile, acquisitionConstantsList },
  syncWithUserConfigurationAPI: 'acquisitionConstants',
});

export const importAcquisitionConstantsProfiles = (
  acquisitionConstantsProfiles: AcquisitionConstantsByProfile
) => ({
  type: XRAY_CONFIGURATION_IMPORT_ACQUISITION_CONSTANT,
  payload: { acquisitionConstantsProfiles },
  syncWithUserConfigurationAPI: 'acquisitionConstants',
});

export type XrayGeneratorConfigurationAction =
  | ReturnType<typeof setDevicePath>
  | ReturnType<typeof toggleTelemetry>
  | ReturnType<typeof toggleDirectCommunicationMode>
  | ReturnType<typeof addOperator>
  | ReturnType<typeof setSelectedOperators>
  | ReturnType<typeof deleteOperator>
  | ReturnType<typeof updateAcquisitionConstant>
  | ReturnType<typeof importAcquisitionConstantsProfiles>
  | LoadSharedUserConfigAction;
